import styled from 'styled-components';

export const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
`;

export const FileInputLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${props => props.theme.colors.buttons.textButton};
  text-transform: uppercase;
`;

export const DeviceCameraBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 14px;
  background-color: #1c1b1f;
  color: #ffffff;
  padding: 16px;
  gap: 12px;
  border-radius: 12px;
`;
